const DISCOVERY_TOPICS = [
  'Right fit',
  'Certification path',
  'Bali logistics',
  'Online study',
  'Pricing',
  'Other',
]

const BALI_TIME_ZONE = 'Asia/Makassar'

export const createAssistantDiscoveryCall = ({ container, onBack }) => {
  const requesterTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || BALI_TIME_ZONE
  let slots = []
  let selectedDateKey = ''
  let selectedSlotId = ''
  let timeDisplay = 'bali'
  let monthIndex = 0
  let selectedCall = null
  let slotLoadRequest = 0
  let submissionRequest = 0
  let flowGeneration = 0
  let sourcePage = 'assistant'
  let disposed = false
  const unavailableSlotIds = new Set()

  container.innerHTML = `
    <section class="assistant-discovery" aria-labelledby="assistant-discovery-title">
      <form class="assistant-discovery__form" novalidate>
        <div class="assistant-discovery__topline">
          <button class="assistant-discovery__text-button" type="button" data-discovery-action="home">← Back</button>
          <div class="assistant-discovery__progress">
            <span class="assistant-discovery__sr-only" data-discovery-progress-label role="status" aria-live="polite" aria-atomic="true">Step 1 of 3</span>
            <span class="assistant-discovery__progress-bar is-active" aria-hidden="true"></span>
            <span class="assistant-discovery__progress-bar" aria-hidden="true"></span>
            <span class="assistant-discovery__progress-bar" aria-hidden="true"></span>
          </div>
        </div>

        <div class="assistant-discovery__step" data-discovery-step="slot">
          <div class="assistant-discovery__intro">
            <h2 id="assistant-discovery-title" data-discovery-slot-heading tabindex="-1">Choose a time</h2>
            <p>Available Monday, Wednesday, and Saturday from 8am–7pm Bali time.</p>
          </div>
          <div class="assistant-discovery__alert" data-discovery-alert role="alert" hidden></div>
          <div class="assistant-discovery__loading" data-discovery-loading role="status" aria-live="polite" tabindex="-1">Loading available times…</div>
          <button class="assistant-discovery__secondary" type="button" data-discovery-action="retry-slots" hidden>Retry available times</button>
          <div class="assistant-discovery__calendar" data-discovery-calendar hidden>
            <div class="assistant-discovery__calendar-header">
              <button type="button" data-discovery-action="month-previous" aria-label="Previous month">‹</button>
              <strong data-discovery-month-label></strong>
              <button type="button" data-discovery-action="month-next" aria-label="Next month">›</button>
            </div>
            <div class="assistant-discovery__weekdays" aria-hidden="true">
              <span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span>
            </div>
            <div class="assistant-discovery__calendar-grid" data-discovery-calendar-grid></div>
          </div>
          <div class="assistant-discovery__times" data-discovery-times hidden>
            <div class="assistant-discovery__time-toggle" aria-label="Choose how times are displayed">
              <button type="button" data-time-display="bali" aria-pressed="true">Bali time</button>
              <button type="button" data-time-display="local" aria-pressed="false">Your time</button>
            </div>
            <div class="assistant-discovery__time-options" data-discovery-time-options></div>
          </div>
          <small class="assistant-discovery__field-error" data-error-for="discovery_call_slot_id" hidden></small>
          <div class="assistant-discovery__actions">
            <button class="assistant-discovery__primary" type="button" data-discovery-action="slot-next">Choose topics</button>
          </div>
        </div>

        <div class="assistant-discovery__step" data-discovery-step="topic" hidden>
          <div class="assistant-discovery__intro">
            <h2 id="assistant-discovery-topic-title">What would you like to ask?</h2>
            <p>Topics are optional. Select any you would like Maria to prepare for, or continue without choosing.</p>
          </div>
          <div class="assistant-discovery__alert" data-discovery-alert role="alert" hidden></div>
          <fieldset class="assistant-discovery__topics">
            <legend class="assistant-discovery__sr-only">Discovery call topics</legend>
            ${DISCOVERY_TOPICS.map(topic => `
              <label>
                <input name="selected_topics" type="checkbox" value="${topic}">
                <span>${topic}</span>
              </label>
            `).join('')}
          </fieldset>
          <label class="assistant-discovery__field" data-discovery-other hidden>
            <span>Tell us a little more</span>
            <textarea name="message" maxlength="1000" rows="3" placeholder="What would you like Maria to know?"></textarea>
            <small data-error-for="message" hidden></small>
          </label>
          <div class="assistant-discovery__actions">
            <button class="assistant-discovery__secondary" type="button" data-discovery-action="topic-back">Back</button>
            <button class="assistant-discovery__primary" type="button" data-discovery-action="topic-next">Continue to details</button>
          </div>
        </div>

        <div class="assistant-discovery__step" data-discovery-step="contact" hidden>
          <div class="assistant-discovery__intro">
            <h2 id="assistant-discovery-contact-title">Confirm your call</h2>
            <p>Enter your details to book the selected time.</p>
          </div>
          <div class="assistant-discovery__summary" data-discovery-selected-time></div>
          <div class="assistant-discovery__alert" data-discovery-alert role="alert" hidden></div>
          <label class="assistant-discovery__field">
            <span>Full name</span>
            <input name="full_name" type="text" autocomplete="name" maxlength="120" required placeholder="Full name">
            <small data-error-for="full_name" hidden></small>
          </label>
          <label class="assistant-discovery__field">
            <span>Email address</span>
            <input name="email" type="email" autocomplete="email" maxlength="255" required placeholder="Email address">
            <small data-error-for="email" hidden></small>
          </label>
          <label class="assistant-discovery__field">
            <span>Phone or WhatsApp <em>Optional</em></span>
            <input name="phone" type="tel" autocomplete="tel" inputmode="tel" maxlength="40" placeholder="+62 812 3456 7890">
            <small data-error-for="phone" hidden></small>
          </label>
          <label class="assistant-discovery__honeypot" aria-hidden="true">
            Website
            <input name="website" type="text" autocomplete="off" tabindex="-1">
          </label>
          <div class="assistant-discovery__actions">
            <button class="assistant-discovery__secondary" type="button" data-discovery-action="contact-back">Back</button>
            <button class="assistant-discovery__primary" type="submit">Confirm booking</button>
          </div>
        </div>
      </form>

      <div class="assistant-discovery__success" data-discovery-success hidden>
        <button class="assistant-discovery__text-button" type="button" data-discovery-action="home">← Assistant home</button>
        <div class="assistant-discovery__success-mark" aria-hidden="true">✓</div>
        <h2>Your call is booked.</h2>
        <p>We saved your selected time and sent the details to the Rooted Movement team. You will also receive a confirmation email.</p>
        <div class="assistant-discovery__summary" data-discovery-summary></div>
        <div class="assistant-discovery__success-actions" data-discovery-success-actions></div>
      </div>
    </section>
  `

  const form = container.querySelector('.assistant-discovery__form')
  const success = container.querySelector('[data-discovery-success]')
  const progress = container.querySelector('.assistant-discovery__progress')
  const loading = container.querySelector('[data-discovery-loading]')
  const calendar = container.querySelector('[data-discovery-calendar]')
  const calendarGrid = container.querySelector('[data-discovery-calendar-grid]')
  const monthLabel = container.querySelector('[data-discovery-month-label]')
  const times = container.querySelector('[data-discovery-times]')
  const timeOptions = container.querySelector('[data-discovery-time-options]')
  const otherField = container.querySelector('[data-discovery-other]')
  const slotHeading = container.querySelector('[data-discovery-slot-heading]')
  const retrySlotsButton = container.querySelector('[data-discovery-action="retry-slots"]')
  const slotNextButton = container.querySelector('[data-discovery-action="slot-next"]')
  const submitButton = form.querySelector('button[type="submit"]')

  const field = name => form.elements.namedItem(name)
  const currentStep = () => form.querySelector('.assistant-discovery__step:not([hidden])')?.dataset.discoveryStep

  const showStep = step => {
    form.querySelectorAll('[data-discovery-step]').forEach(element => {
      element.hidden = element.dataset.discoveryStep !== step
    })
    container.querySelector('.assistant-discovery').setAttribute('aria-labelledby', step === 'slot' ? 'assistant-discovery-title' : `assistant-discovery-${step}-title`)
    const stepNumber = ({ slot: 1, topic: 2, contact: 3 })[step]
    if (step === 'contact') {
      const slot = slots.find(slot => String(slot.id) === String(selectedSlotId))
      const summary = container.querySelector('[data-discovery-selected-time]')
      const label = document.createElement('strong')
      label.textContent = formatSlot(slot, BALI_TIME_ZONE)
      summary.replaceChildren(label)
      if (requesterTimeZone !== BALI_TIME_ZONE) {
        const localTime = document.createElement('span')
        localTime.textContent = `Your time: ${formatSlot(slot, requesterTimeZone)}`
        summary.append(localTime)
      }
    }
    progress.querySelector('[data-discovery-progress-label]').textContent = `Step ${stepNumber} of 3`
    progress.querySelectorAll('.assistant-discovery__progress-bar').forEach((bar, index) => {
      bar.classList.toggle('is-active', index < stepNumber)
    })
    clearErrors()
    container.closest('.rooted-assistant__conversation')?.scrollTo({ top: 0, behavior: 'smooth' })
    const generation = flowGeneration
    window.requestAnimationFrame(() => {
      if (disposed || generation !== flowGeneration || currentStep() !== step || container.closest('[inert]')) return
      if (step === 'contact') field('full_name')?.focus()
      if (step === 'slot') {
        renderCalendar()
        slotHeading.focus()
      }
      if (step === 'topic') form.querySelector('input[name="selected_topics"]')?.focus()
    })
  }

  const clearErrors = () => {
    container.querySelectorAll('[data-error-for]').forEach(error => {
      error.hidden = true
      error.textContent = ''
    })
    container.querySelectorAll('[data-discovery-alert]').forEach(alert => {
      alert.hidden = true
      alert.textContent = ''
    })
  }

  const showErrors = errors => {
    clearErrors()
    const normalized = normalizeErrors(errors)
    let firstError = null

    Object.entries(normalized).forEach(([key, message]) => {
      const error = container.querySelector(`[data-error-for="${key}"]`)
      if (error) {
        error.textContent = message
        error.hidden = false
        firstError ||= error
      } else {
        const alert = container.querySelector(`[data-discovery-step="${currentStep()}"] [data-discovery-alert]`)
        if (alert) {
          alert.textContent = message
          alert.hidden = false
          firstError ||= alert
        }
      }
    })

    firstError?.setAttribute('tabindex', '-1')
    firstError?.scrollIntoView({ block: 'nearest' })
    firstError?.focus({ preventScroll: true })
  }

  const validateContact = () => {
    const errors = {}
    const name = field('full_name').value.trim()
    const email = field('email').value.trim()

    if (!name) errors.full_name = 'Enter your name.'
    if (!email) errors.email = 'Enter your email address.'
    else if (!field('email').validity.valid) errors.email = 'Enter a valid email address.'

    if (Object.keys(errors).length) {
      showErrors(errors)
      return false
    }

    return true
  }

  const loadSlots = async () => {
    const requestId = ++slotLoadRequest
    clearErrors()
    retrySlotsButton.hidden = true
    loading.hidden = false
    loading.textContent = 'Loading available times…'
    calendar.hidden = true
    times.hidden = true
    slotNextButton.disabled = true

    try {
      const response = await fetch('/discovery-call-slots', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error('Unable to load available times.')
      if (requestId !== slotLoadRequest) return

      slots = Array.isArray(data.slots)
        ? data.slots
          .map(slot => formatDiscoverySlot(slot, requesterTimeZone))
          .filter(slot => !unavailableSlotIds.has(String(slot.id)))
        : []
      selectedDateKey = ''
      selectedSlotId = ''
      monthIndex = 0
      loading.hidden = slots.length > 0
      loading.textContent = slots.length ? '' : 'No discovery call slots are available right now. Please check back soon or write to Maria on WhatsApp.'
      calendar.hidden = slots.length === 0
      retrySlotsButton.hidden = slots.length > 0
      slotNextButton.disabled = slots.length === 0
      renderCalendar()
      if (currentStep() === 'slot') {
        window.requestAnimationFrame(() => {
          if (disposed || requestId !== slotLoadRequest || currentStep() !== 'slot' || container.closest('[inert]')) return
          // Do not steal focus if the visitor already moved on from the heading.
          const active = container.getRootNode().activeElement
          if (active === slotHeading) (calendar.querySelector('.assistant-discovery__day.has-slots') || loading).focus()
        })
      }
    } catch (_error) {
      if (requestId !== slotLoadRequest) return
      slots = []
      retrySlotsButton.hidden = false
      loading.hidden = false
      loading.textContent = 'Available times could not be loaded. Please try again.'
      slotNextButton.disabled = true
      showErrors({ base: 'Available times could not be loaded. Please try again.' })
    }
  }

  const renderCalendar = () => {
    if (!slots.length) {
      calendarGrid.replaceChildren()
      timeOptions.replaceChildren()
      calendar.hidden = true
      times.hidden = true
      slotNextButton.disabled = true
      return
    }

    const months = calendarMonths(slots)
    monthIndex = Math.min(monthIndex, Math.max(months.length - 1, 0))
    const month = months[monthIndex]
    if (!month) return

    monthLabel.textContent = month.label
    const previous = container.querySelector('[data-discovery-action="month-previous"]')
    const next = container.querySelector('[data-discovery-action="month-next"]')
    previous.disabled = monthIndex === 0
    next.disabled = monthIndex >= months.length - 1
    calendarGrid.replaceChildren()

    calendarDays(month, slots).forEach(day => {
      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'assistant-discovery__day'
      button.dataset.dateKey = day.key
      button.disabled = day.slots.length === 0
      button.classList.toggle('is-muted', !day.isCurrentMonth)
      button.classList.toggle('has-slots', day.slots.length > 0)
      button.classList.toggle('is-active', selectedDateKey === day.key)
      button.setAttribute('aria-label', day.slots.length ? `${day.label}, ${day.slots.length} available ${day.slots.length === 1 ? 'time' : 'times'}` : day.label)
      button.innerHTML = `<span>${day.day}</span>${day.slots.length ? '<i aria-hidden="true"></i>' : ''}`
      calendarGrid.append(button)
    })

    renderTimes()
  }

  const renderTimes = () => {
    const dateSlots = slots.filter(slot => slot.dateKey === selectedDateKey)
    times.hidden = dateSlots.length === 0
    timeOptions.replaceChildren()

    dateSlots.forEach(slot => {
      const label = document.createElement('label')
      label.className = 'assistant-discovery__time-option'
      const radio = document.createElement('input')
      radio.type = 'radio'
      radio.name = 'discovery_call_slot_id'
      radio.value = slot.id
      radio.checked = String(selectedSlotId) === String(slot.id)
      const text = document.createElement('span')
      text.textContent = timeDisplay === 'bali' ? slot.baliLabel : slot.localLabel
      label.append(radio, text)
      timeOptions.append(label)
    })
  }

  const reset = () => {
    form.reset()
    success.hidden = true
    form.hidden = false
    selectedCall = null
    flowGeneration += 1
    slotLoadRequest += 1
    submissionRequest += 1
    submitButton.disabled = false
    submitButton.textContent = 'Confirm booking'
    slots = []
    selectedDateKey = ''
    selectedSlotId = ''
    timeDisplay = 'bali'
    monthIndex = 0
    otherField.hidden = true
    container.querySelectorAll('[data-time-display]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.timeDisplay === 'bali'))
    })
    container.querySelector('[data-discovery-selected-time]').replaceChildren()
    showStep('slot')
  }

  const open = (options = {}) => {
    if (disposed) return
    sourcePage = typeof options?.sourcePage === 'string' && options.sourcePage.trim()
      ? options.sourcePage
      : 'assistant'
    reset()
    loadSlots()
  }

  container.addEventListener('click', event => {
    if (disposed || submitButton.disabled) return
    const actionButton = event.target.closest('[data-discovery-action]')
    const dayButton = event.target.closest('[data-date-key]')
    const displayButton = event.target.closest('[data-time-display]')

    if (dayButton) {
      selectedDateKey = dayButton.dataset.dateKey
      selectedSlotId = ''
      renderCalendar()
      window.requestAnimationFrame(() => times.scrollIntoView({ block: 'nearest', behavior: 'smooth' }))
      return
    }

    if (displayButton) {
      timeDisplay = displayButton.dataset.timeDisplay
      container.querySelectorAll('[data-time-display]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === displayButton))
      })
      renderTimes()
      return
    }

    if (!actionButton) return

    switch (actionButton.dataset.discoveryAction) {
      case 'home':
        onBack()
        break
      case 'retry-slots':
        loadSlots()
        break
      case 'contact-back':
        showStep('topic')
        break
      case 'topic-next':
        showStep('contact')
        break
      case 'slot-next':
        if (!selectedSlotId) showErrors({ discovery_call_slot_id: 'Choose an available time.' })
        else showStep('topic')
        break
      case 'topic-back':
        showStep('slot')
        break
      case 'month-previous':
        monthIndex = Math.max(0, monthIndex - 1)
        selectedDateKey = ''
        selectedSlotId = ''
        renderCalendar()
        break
      case 'month-next':
        monthIndex += 1
        selectedDateKey = ''
        selectedSlotId = ''
        renderCalendar()
        break
    }
  })

  container.addEventListener('change', event => {
    if (event.target.matches('input[name="discovery_call_slot_id"]')) {
      selectedSlotId = event.target.value
      clearErrors()
    }

    if (event.target.matches('input[name="selected_topics"]')) {
      otherField.hidden = !Array.from(form.querySelectorAll('input[name="selected_topics"]:checked')).some(input => input.value === 'Other')
    }
  })

  form.addEventListener('submit', async event => {
    event.preventDefault()
    if (disposed || currentStep() !== 'contact' || submitButton.disabled || form.hidden) return
    if (!validateContact()) return
    if (!selectedSlotId) {
      showStep('slot')
      showErrors({ discovery_call_slot_id: 'Choose an available time.' })
      return
    }

    const submittedSlotId = selectedSlotId
    const selectedSlot = slots.find(slot => String(slot.id) === String(submittedSlotId))
    const selectedTopics = Array.from(form.querySelectorAll('input[name="selected_topics"]:checked')).map(input => input.value)
    const requestId = ++submissionRequest
    const requestFlowGeneration = flowGeneration
    const requestIsCurrent = () => requestId === submissionRequest && requestFlowGeneration === flowGeneration
    submitButton.disabled = true
    submitButton.textContent = 'Booking…'
    clearErrors()

    try {
      const response = await fetch('/discovery-call-requests', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
        },
        body: JSON.stringify({
          discovery_call_request: {
            full_name: field('full_name').value.trim(),
            email: field('email').value.trim(),
            phone: field('phone').value.trim(),
            requester_time_zone: requesterTimeZone,
            discovery_call_slot_id: submittedSlotId,
            selected_topics: selectedTopics,
            preferred_time: selectedSlot?.baliLabel || '',
            message: selectedTopics.includes('Other') ? field('message').value.trim() : '',
            source_page: sourcePage,
            website: field('website').value,
          },
        }),
      })
      const data = await response.json().catch(() => ({}))
      if (!requestIsCurrent()) return

      if (!response.ok) {
        const errors = normalizeErrors(data.errors)
        if (errors.full_name || errors.email || errors.phone) showStep('contact')
        else if (errors.message || errors.selected_topics) showStep('topic')
        else if (errors.discovery_call_slot_id) {
          if (isUnavailableSlotError(errors.discovery_call_slot_id)) unavailableSlotIds.add(String(submittedSlotId))
          selectedSlotId = ''
          showStep('slot')
          await loadSlots()
          if (!requestIsCurrent()) return
        }
        showErrors(errors)
        return
      }

      selectedCall = data.discovery_call || null
      showSuccess()
    } catch (_error) {
      if (requestIsCurrent()) showErrors({ base: 'Something went wrong. Please try again.' })
    } finally {
      if (requestIsCurrent()) {
        submitButton.disabled = false
        submitButton.textContent = 'Confirm booking'
      }
    }
  })

  const showSuccess = () => {
    form.hidden = true
    success.hidden = false
    const summary = container.querySelector('[data-discovery-summary]')
    const actions = container.querySelector('[data-discovery-success-actions]')
    summary.replaceChildren()
    actions.replaceChildren()

    if (selectedCall) {
      const localTime = document.createElement('strong')
      localTime.textContent = formatSlot({ startsAt: selectedCall.starts_at, endsAt: selectedCall.ends_at }, selectedCall.requester_time_zone || requesterTimeZone)
      const baliTime = document.createElement('span')
      baliTime.textContent = selectedCall.bali_label || ''
      summary.append(localTime, baliTime)

      if (selectedCall.meeting_url) actions.append(successLink('Join call', selectedCall.meeting_url))
      actions.append(successLink('Add to Google Calendar', googleCalendarUrl(selectedCall)))
      const calendarLink = successLink('Add to Apple / Outlook', icsCalendarUrl(selectedCall))
      calendarLink.download = 'rooted-movement-discovery-call.ics'
      actions.append(calendarLink)
    }

    container.closest('.rooted-assistant__conversation')?.scrollTo({ top: 0, behavior: 'smooth' })
    window.requestAnimationFrame(() => success.querySelector('button')?.focus())
  }

  const destroy = () => {
    disposed = true
    flowGeneration += 1
    slotLoadRequest += 1
    submissionRequest += 1
    sourcePage = 'assistant'
    form.reset()
    slots = []
    selectedCall = null
  }

  return { open, destroy }
}

export const formatDiscoverySlot = (slot, requesterTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || BALI_TIME_ZONE) => ({
  ...slot,
  id: String(slot.id),
  dateKey: slotDateKey(slot),
  baliLabel: slot.baliLabel || formatSlot(slot, BALI_TIME_ZONE),
  localLabel: formatSlot(slot, requesterTimeZone),
})

export const slotDateKey = slot => {
  if (!slot?.startsAt) return ''
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: BALI_TIME_ZONE,
  }).formatToParts(new Date(slot.startsAt)).map(part => [part.type, part.value]))

  return `${parts.year}-${parts.month}-${parts.day}`
}

export const formatSlot = (slot, timeZone) => {
  if (!slot?.startsAt) return ''
  const startsAt = new Date(slot.startsAt)
  const endsAt = new Date(slot.endsAt)
  const date = new Intl.DateTimeFormat('en', { weekday: 'short', month: 'short', day: 'numeric', timeZone }).format(startsAt)
  const start = new Intl.DateTimeFormat('en', { hour: 'numeric', minute: '2-digit', timeZone }).format(startsAt)
  const end = new Intl.DateTimeFormat('en', { hour: 'numeric', minute: '2-digit', timeZone }).format(endsAt)
  return `${date}, ${start}–${end} (${timeZone})`
}

const calendarMonths = slots => {
  const keys = [...new Set(slots.map(slot => slot.dateKey.slice(0, 7)))].sort()
  return keys.map(key => {
    const [year, month] = key.split('-').map(Number)
    const date = new Date(year, month - 1, 1)
    return {
      key,
      date,
      label: new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(date),
    }
  })
}

const calendarDays = (month, slots) => {
  const year = month.date.getFullYear()
  const monthIndex = month.date.getMonth()
  const firstOfMonth = new Date(year, monthIndex, 1)
  const mondayOffset = (firstOfMonth.getDay() + 6) % 7
  const start = new Date(year, monthIndex, 1 - mondayOffset)
  const slotsByDate = new Map()

  slots.forEach(slot => {
    if (!slotsByDate.has(slot.dateKey)) slotsByDate.set(slot.dateKey, [])
    slotsByDate.get(slot.dateKey).push(slot)
  })

  return Array.from({ length: 42 }, (_, index) => {
    const date = new Date(start)
    date.setDate(start.getDate() + index)
    const key = localDateKey(date)
    return {
      key,
      day: date.getDate(),
      label: new Intl.DateTimeFormat('en', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(date),
      slots: slotsByDate.get(key) || [],
      isCurrentMonth: date.getMonth() === monthIndex,
    }
  })
}

const localDateKey = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

const normalizeErrors = errors => {
  const normalized = errors || { base: 'Please check the highlighted fields and try again.' }
  return Object.fromEntries(Object.entries(normalized).map(([key, value]) => [key, Array.isArray(value) ? value[0] : value]))
}

const isUnavailableSlotError = error => error?.toString().toLowerCase().includes('no longer available')

const calendarTimestamp = value => new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z')

const calendarDescription = call => call.meeting_url
  ? `Discovery call with Rooted Movement Pilates. Meeting link: ${call.meeting_url}`
  : 'Discovery call with Rooted Movement Pilates. The final call link will be sent by email.'

const googleCalendarUrl = call => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: 'Rooted Movement Discovery Call',
    dates: `${calendarTimestamp(call.starts_at)}/${calendarTimestamp(call.ends_at)}`,
    details: calendarDescription(call),
  })
  return `https://calendar.google.com/calendar/render?${params.toString()}`
}

const icsCalendarUrl = call => {
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Rooted Movement Pilates//Discovery Call//EN',
    'BEGIN:VEVENT',
    `UID:${Date.now()}@rootedmovement.co`,
    `DTSTAMP:${calendarTimestamp(new Date().toISOString())}`,
    `DTSTART:${calendarTimestamp(call.starts_at)}`,
    `DTEND:${calendarTimestamp(call.ends_at)}`,
    'SUMMARY:Rooted Movement Discovery Call',
    `DESCRIPTION:${calendarDescription(call)}`,
    'BEGIN:VALARM',
    'TRIGGER:-PT15M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Rooted Movement discovery call starts in 15 minutes',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\n')
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`
}

const successLink = (label, href) => {
  const link = document.createElement('a')
  link.href = href
  link.textContent = label
  if (!href.startsWith('data:')) {
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
  }
  return link
}
